<template lang="html">
    <div class="checkout__body">
        <ul class="checkout__steps">
            <li class="checkout-step" :class="{ opened : ~expadedSteps.indexOf(1) }" >
                <div class="checkout-step__top" @click.prevent="toggleStep(1)" >
                    <div class="checkout-step__counter"><span>03</span></div>
                    <h3 class="checkout-step__title">Выбрать услуги</h3>
                    <span class="checkout-step__toggler"></span>
                </div>
                <div class="checkout-step__inner">
                    <div class="checkout-step__item">
                        <span class="checkout-step__item-name">услуги</span>
                        <ul class="checkout-step__form">
                            <li class="checkout-step__form-item checkout-step__form-item--wide">
                                <div class="checkout-services">
                                    <ul class="checkout-services__list">
                                        <li v-for="item in serviceGroups" :key="item.ID" class="checkout-services__item" data-responsive-dropdown >
                                            <div class="checkout-services__item-top">
                                                <p class="checkout-services__item-title">{{ item.UF_TITLE }}</p>
                                            </div>
                                            <div class="checkout-services__item-bottom">
                                                <div class="checkout-tabs checkout-tabs--services">
                                                    <ul class="checkout-tabs__list">
                                                        <li v-for="serv in servicesByGroup[ item.ID ]" :key="serv.ID" @click="toggleService(serv)" :class="{ 'checkout-tabs__tab--active' : !!selectedServices[ serv.ID ] }" class="checkout-tabs__tab" >
                                                            <p class="checkout-tabs__tab-title">{{ serv.UF_NAME }}</p>
                                                            <span v-if="+serv.PRICE > 0" class="checkout-tabs__tab-subtitle">{{ serv.PRICE }} ₽</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                    <!-- <div class="checkout-services__more">
                                    <a class="link" href="#">Не нашли необходимую услугу?</a>
                                    <div class="form-item">
                                    <label class="form-item__label">Услуга</label>
                                    <div class="default-input">
                                    <input type="text" placeholder="Введите услугу">
                                </div>
                            </div>
                        </div> -->
                    </div>
                </li>
            </ul>
        </div>
    </div>
</li>
<li class="checkout-step" :class="{ opened : ~expadedSteps.indexOf(3) }" >
    <div class="checkout-step__top" @click.prevent="toggleStep(3)">
        <div class="checkout-step__counter"><span>03</span></div>
        <h3 class="checkout-step__title">Ваш автомобиль</h3>
        <span class="checkout-step__toggler"></span>
    </div>
    <div class="checkout-step__inner">
        <div class="checkout-step__item">
            <span class="checkout-step__item-name">автомобиль</span>
            <div class="checkout-step__form">
                <div v-if="personalCars.length" class="checkout-step__form-item checkout-step__form-item--wide" >
                    <p class="checkout-step__text">Выберите ваш автомобиль для экономии времени заполнения заявки.<br>При выборе автомобиля все параметры подставятся автоматически</p>
                </div>
                <div class="checkout-step__form-item checkout-form">
                    <div class="checkout-form__items">
                        <div v-if="personalCars.length" class="form-item">
                            <label class="form-item__label">Ваш автомобиль</label>
                            <div class="default-select">
                                <roscar-select v-model="selectedPersonalCarId" v-slot="slotProps" >
                                    <select :ref="el => slotProps.params.selectElement = el" v-model="selectedPersonalCarId" class="default-select__select" data-placeholder="Выберите автомобиль" data-no-deselect="true">
                                        <option data-placeholder="true"></option>
                                        <option v-for="item in personalCars" :key="item.ID" :value="item.ID" >{{ item.UF_BRAND }} {{ item.UF_MODEL }} {{ item.UF_SHELL }}, {{ item.UF_YEAR }}</option>
                                    </select>
                                </roscar-select>
                            </div>
                        </div>
                        <car-selector v-slot="carSelectorSlotProps" :type="[ 'cars' ]"
                        v-model:brand="car.brand"
                        v-model:model="car.model"
                        >
                        <div class="form-item required">
                            <label class="form-item__label">Марка</label>
                            <div class="default-select" :key="carSelectorSlotProps.params.brand" >
                                <roscar-select>
                                    <select v-model="carSelectorSlotProps.params.brand" class="default-select__select" data-placeholder="Выберите марку авто" data-no-deselect="true">
                                        <option data-placeholder="true"></option>
                                        <option v-for="val in carSelectorSlotProps.brands" :key="val" :value="val" v-html="val" ></option>
                                    </select>
                                </roscar-select>
                            </div>
                        </div>
                        <div v-if="carSelectorSlotProps.models.length" class="form-item required">
                            <label class="form-item__label">Модель</label>
                            <div class="default-select" :key="carSelectorSlotProps.params.model" >
                                <roscar-select >
                                    <select v-model="carSelectorSlotProps.params.model" class="default-select__select" data-placeholder="Выберите модель авто" data-no-deselect="true">
                                        <option data-placeholder="true"></option>
                                        <option v-for="val in carSelectorSlotProps.models" :key="val" :value="val" v-html="val" ></option>
                                    </select>
                                </roscar-select>
                            </div>
                        </div>
                    </car-selector>
                    <div class="form-item required">
                        <label class="form-item__label">Госномер</label>
                        <div class="default-input">
                            <input-mask v-keyboard.right.car v-model="car.licenseNumber" required placeholder="Введите госномер автомобиля" :definitions="{ 'x' : /[аАвВеЕкКмМнНоОрРсСтТуУхХ]/ }" mask="x000xx" ></input-mask>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</li>
<li class="checkout-step" :class="{ opened : ~expadedSteps.indexOf(4) }" ref="contactInfo">
    <div class="checkout-step__top" @click.prevent="toggleStep(4)">
        <div class="checkout-step__counter"><span>03</span></div>
        <h3 class="checkout-step__title">Записаться</h3>
        <span class="checkout-step__toggler" ></span>
    </div>
    <div class="checkout-step__inner">
        <div class="checkout-step__item">
            <span class="checkout-step__item-name">сервисный центр</span>
            <div class="checkout-step__form">
                <div class="checkout-step__form-item checkout-form">
                    <div class="checkout-form__items">
                        <div class="form-item required">
                            <label class="form-item__label">Сервис</label>
                            <div class="default-select" :key="selectedCenterId" >
                                <roscar-select >
                                    <select class="default-select__select" v-model="selectedCenterId" data-placeholder="Выберите сервис" data-no-deselect="true">
                                        <option data-placeholder="true"></option>
                                        <option v-for="item in availableCenters" :key="item.ID" :value="item.ID" >{{ item.ADDRESS }}</option>
                                    </select>
                                </roscar-select>
                            </div>
                        </div>
                        <a v-if="availableCenters.length" class="link" href="#" @click.prevent="$refs.availableStoresPopup.open()" >показать на карте</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="checkout-step__item">
            <span class="checkout-step__item-name">желаемая дата</span>
            <div class="checkout-step__form">
                <div class="checkout-step__form-item checkout-form">
                    <div class="checkout-form__items">
                        <div class="form-item form-item--daytime">
                            <label class="form-item__label">Выбрать дату</label>
                            <div class="default-calendar">
                                <roscar-calendar :model-value="selectedDate" @update:modelValue="selectedDate = $event[0]" ></roscar-calendar>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="selectedDate && selectedCenterId" class="checkout-step__item">
            <span class="checkout-step__item-name">желаемое время</span>
            <div class="checkout-step__form">
                <div class="checkout-step__form-item checkout-form">
                    <div class="checkout-form__items">
                        <div class="form-item form-item--daytime">
                            <label class="form-item__label">Выбрать время</label>
                            <ul v-if="availableTime.length" class="default-timeselect">
                                <li v-for="time in availableTime" :key="time" @click.prevent="selectTime(time)" class="default-timeselect__item" :class="{ 'default-timeselect__item--active' : selectedTime == time }" >{{ time }}</li>
                            </ul>
                            <div v-else-if="availableTimeLoaded" >
                                На указанную дату нет доступного времени
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="checkout-step__item">
            <span class="checkout-step__item-name">контактные<br> данные</span>
            <div class="checkout-step__form">
                <div class="checkout-step__form-item checkout-form">
                    <div class="checkout-form__items">
                        <div class="form-item required">
                            <label class="form-item__label">ФИО</label>
                            <div class="default-input">
                                <input v-keyboard.right.fio v-model="client.name" type="text" placeholder="Введите ваши ФИО" required name="spares-name">
                            </div>
                        </div>
                        <div class="form-item required">
                            <label class="form-item__label">Контактный телефон</label>
                            <div class="default-input">
                                <input-phone v-keyboard.right.phone v-model="client.phone" required ></input-phone>
                            </div>
                        </div>
                    </div>
                    <div class="checkout-form__suggestion">
                        <slot name="policy"></slot>
                    </div>
                    <div class="checkout-form__submit">
                        <button class="btn" @click.prevent="submit()" >Оставить заявку на сервис</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</li>
</ul>
<article v-if="Object.keys(selectedServices).length || car.brand || selectedCenter.ADDRESS || selectedDateFormatted" class="service-total" >
    <template v-if="Object.keys(selectedServices).length" >
        <p class="service-total__title">Услуги | {{ Object.keys(selectedServices).length }}</p>
        <ul class="service-total__items">
            <li v-for="item in selectedServices" :key="item.ID" class="service-total__item">
                <div class="service-total__item-info">
                    <p class="service-total__item-name">{{ item.UF_NAME }}</p>
                    <span v-if="+item.PRICE > 0" class="service-total__item-price">{{ item.PRICE }} ₽</span>
                </div>
                <a class="service-total__item-remove" href="#" @click.prevent="toggleService(item)" ></a>
            </li>
        </ul>
    </template>
    <ul v-if="car.brand || selectedCenter.ADDRESS || selectedDateFormatted" class="service-total__info">
        <li v-if="car.brand" class="service-total__info-item">
            <span class="service-total__info-label">Автомобиль</span>
            <p>{{ [ car.brand, car.model ].filter(v=>v).join(' ') || ' - ' }}</p>
        </li>
        <li v-if="selectedCenter.ADDRESS" class="service-total__info-item">
            <span class="service-total__info-label">Сервисный центр</span>
            <p>{{ selectedCenter.ADDRESS || ' - ' }}</p>
        </li>
        <li v-if="selectedDateFormatted" class="service-total__info-item">
            <span class="service-total__info-label">Дата и время</span>
            <p>{{ [ selectedDateFormatted, selectedTime ].filter(v=>v).join(', ') || ' - ' }}</p>
        </li>
    </ul>
</article>
<div class="checkout__bottom">
    <div class="checkout__suggestion">
        <slot name="policy-right"></slot>
    </div>
    <div class="checkout__submit">
        <button class="btn" @click.prevent="submit()" >Оставить заявку на сервис</button>
    </div>
</div>
</div>

<popup-block ref="serviceOrderCompletePopup" type="right" @close="goTo('/')" >
    <div class="popup__title">
        <h2 class="popup__title-title">Запись оформлена</h2>
    </div>
    <p class="popup__text popup__text--bold">
        Спасибо, в ближайшее время Вам придет SMS с  подтверждением даты и времени.
        <br/><br/>
        <a v-if="calendarLink" :href="calendarLink" :target="~calendarLink.indexOf('://') ? '_blank' : false" class="link">Добавить запись в календарь</a>
    </p>
</popup-block>

<popup-block ref="availableStoresPopup" v-slot="availableStoresPopupSlotProps" type="right" class="popup--map" >
    <stores-list-map >
        <template v-slot:map >
            <yandex-map :placemarks="mapPlacemarks" height="100%" @placemark:selected="mapPlacemarkSelected($event); availableStoresPopupSlotProps.close();" ></yandex-map>
        </template>
        <template v-slot:list >
            <label v-for="item in availableCenters" :key="item.STORE_ID" class="services-list__item" >
                <input type="radio" :checked="selectedCenterId == item.ID" :value="selectedCenterId" name="selected_store_id" />
                <span class="services-list__item-radio"></span>
                <div class="services-list__item-desc">
                    <p class="services-list__item-name">{{ item.ADDRESS }}</p>
                    <ul class="services-list__item-schedule">
                        <li v-if="item.WORK_DAYS_START && item.WORK_DAYS_END" >Пн-Пт: {{ item.WORK_DAYS_START }} - {{ item.WORK_DAYS_END }}</li>
                        <li v-if="item.WORK_SAT_START && item.WORK_SAT_START == item.WORK_SUNDAY_START && item.WORK_SAT_END == item.WORK_SUNDAY_END" >
                            Сб-Вс: {{ [ item.WORK_SAT_START, (item.WORK_SAT_END != item.WORK_SAT_START ? item.WORK_SAT_END : '') ].filter(v=>v).join(' - ') }}
                        </li>
                        <template v-else >
                            <li v-if="item.WORK_SAT_START" >Сб: {{ [ item.WORK_SAT_START, (item.WORK_SAT_END != item.WORK_SAT_START ? item.WORK_SAT_END : '') ].filter(v=>v).join(' - ') }}</li>
                            <li v-if="item.WORK_SUNDAY_START" >Вс: {{ [ item.WORK_SUNDAY_START, (item.WORK_SUNDAY_END != item.WORK_SUNDAY_START ? item.WORK_SUNDAY_END : '') ].filter(v=>v).join(' - ') }}</li>
                        </template>
                    </ul>
                    <button @click.prevent="selectedCenterId = item.ID; availableStoresPopupSlotProps.close();" class="btn">Выбрать</button>
                </div>
            </label>
        </template>
    </stores-list-map>
</popup-block>
</template>

<script>
import { ref, watch, computed } from 'vue';
import usePersonalCars from '../../composables/usePersonalCars';
import useCities from '../../composables/useCities';
import useInitData from '../../composables/useInitData';
import { loadServices, loadServiceGroups, loadServiceCentersByServices, loadServiceCenterAvailableTime, submitServiceOrder, } from '../../api';
import RoscarCalendar from './../RoscarCalendar';
import showMessage from '../../modules/showMessage';

export default {
    name : 'ServiceOrderAutoservice',
    components : {
        RoscarCalendar,
    },
    setup () {
        const serviceOrderCompletePopup = ref(null);
        const tiresStored = ref(0);
        const calendarLink = ref('');
        const selectedDate = ref('');
        const selectedTime = ref('');
        const selectedCenterId = ref('');
        const car = ref({
            brand : '',
            model : '',
            licenseNumber : '',
        });
        const personalCars = usePersonalCars().cars;
        if (!personalCars.length) {
            usePersonalCars().load();
        }
        const selectedPersonalCarId = ref('');
        watch(selectedPersonalCarId, () => {
            let personalCar = personalCars.value.find(c => c.ID == selectedPersonalCarId.value);
            if (personalCar) {
                car.value.brand = personalCar.UF_BRAND;
                car.value.model = personalCar.UF_MODEL;
                car.value.licenseNumber = personalCar.UF_LICENSE_NUMBER;
            }
        });

        watch(() => car.value.brand, (val, oldVal) => {
            if (oldVal) {
                selectedPersonalCarId.value = '';
            }
        });
        watch(() => car.value.model, (val, oldVal) => {
            if (oldVal) {
                selectedPersonalCarId.value = '';
            }
        });

        const contactInfo = ref(null)
        watch(car, (newValue) => {
            let fullComplete = true
            Object.entries(newValue).forEach(([key, value]) => {
                if (!value) {
                    fullComplete = false
                }
                if (key === 'licenseNumber' && value) {
                    if (value.match(/[^_]+/gi)[0].length < 6) fullComplete = false
                }
            })
            if (fullComplete) {
                contactInfo.value.scrollIntoView({behavior:"smooth" , block: 'start'})
                if (!~expadedSteps.value.indexOf(4)) {
                    expadedSteps.value.push(4);
                }
            }
        },{deep: true});

        const order = ref({
            id : '',
        });
        const initData = useInitData().data;
        const client = ref({
            name : !initData.value.isTerminal ? initData.value.NAME : '',
            phone : !initData.value.isTerminal ? initData.value.PERSONAL_PHONE : '',
            contractNumber : '',
        });
        watch(initData, ()=>{
            client.value.name = !initData.value.isTerminal ? initData.value.NAME : '';
            client.value.phone = !initData.value.isTerminal ? initData.value.PERSONAL_PHONE : '';
        });

        const selectedServices = ref({});
        const availableCenters = ref([]);
        const availableTime = ref([]);
        const services = ref([]);
        const _serviceGroups = ref([]);
        const updateAvailableStores = () => {
            availableCenters.value = [];
            let filterData = new FormData();
            if (Object.keys(selectedServices.value).length) {
                for (var serviceId in selectedServices.value) {
                    filterData.append('services[]', selectedServices.value[serviceId].UF_CODE);
                }
            }
            else {
                return;
            }
            loadServiceCentersByServices(filterData).then(res => {
                availableCenters.value = res.items || [];
                if (res.message) {
                    showMessage(res.message);
                }
            });
        }
        loadServices().then(res => {
            services.value = res.items || [];
        })
        watch(services, () => {
            if (typeof(window.initUi) == 'function') {
                setTimeout(()=>{
                    window.initUi();
                }, 300);
            }
        });

        loadServiceGroups().then(res => {
            _serviceGroups.value = res.items || [];
        })

        const { selectedCityId } = useCities();
        watch(selectedCityId, () => {
            setTimeout(()=>{
                updateAvailableStores();
                loadServices().then(res => {
                    services.value = res.items || [];
                });
            }, 100);
        });
        updateAvailableStores();

        const serviceGroups = computed(() => _serviceGroups.value.filter(o => servicesByGroup.value[ o.ID ]));

        const servicesByGroup = computed(() => {
            let servicesByGroup = {};
            for (var i = 0; i < services.value.length; i++) {
                for (var j = 0; j < services.value[i].UF_SERVICE_TYPE.length; j++) {
                    if (!services.value[i].UF_SERVICE_TYPE[j]) {
                        continue;
                    }
                    if (!servicesByGroup[ services.value[i].UF_SERVICE_TYPE[j] ]) {
                        servicesByGroup[ services.value[i].UF_SERVICE_TYPE[j] ] = [];
                    }
                    servicesByGroup[ services.value[i].UF_SERVICE_TYPE[j] ].push(services.value[i]);
                }
            }
            return servicesByGroup;
        });

        const selectedCenter = computed(() => availableCenters.value.find(c => c.ID == selectedCenterId.value) || {});
        watch(servicesByGroup, () => {
            setTimeout(()=>{
                window.initUi();
            }, 1000);
        });
        watch(availableCenters, () => {
            if (selectedCenterId.value && !availableCenters.value.find(c => c.ID == selectedCenterId.value)) {
                selectedCenterId.value = '';
            }

            if (availableCenters.value.length === 1) {
                selectedCenterId.value = availableCenters.value[0].ID;
            }
        });
        const availableTimeLoaded = ref(false);
        watch([ selectedCenterId, selectedDate ], () => {
            availableTime.value = [];
            availableTimeLoaded.value = false;
            if (selectedDate.value && selectedCenterId.value && Object.keys(selectedServices.value).length) {
                let params = {};
				Object.keys(selectedServices.value).forEach((key, index) => {
					params[ `services[${index}]` ] = selectedServices.value[key].UF_CODE;
				});
                // for (var serviceId in selectedServices.value) {
                //     params[ `services[]` ] = selectedServices.value[serviceId].UF_CODE;
                // }
                loadServiceCenterAvailableTime(selectedCenter.value.CODE, selectedDate.value, params).then(res => {
                    availableTimeLoaded.value = true;
                    availableTime.value = res.items || [];
                });
            }
        });
        watch(availableTime, () => {
            if (
                selectedTime.value &&
                !~availableTime.value.indexOf(selectedTime.value)
            ) {
                selectedTime.value = '';
            }
        });
        const toggleService = service => {
            if (!selectedServices.value[ service.ID ]) {
                selectedServices.value[ service.ID ] = service;
                if (!~expadedSteps.value.indexOf(3)) {
                    expadedSteps.value.push(3);
                }
            }
            else {
                delete selectedServices.value[ service.ID ];
            }
            updateAvailableStores();
        }

        const selectTime = time => {
            if (~availableTime.value.indexOf(time)) {
                selectedTime.value = time;
            }
        }

        const selectedDateFormatted = computed(() => {
            if (!selectedDate.value) {
                return '';
            }
            let dateTimeFormat = new Intl.DateTimeFormat('ru-RU', {
                month: 'long',
                day: 'numeric',
            });
            return dateTimeFormat.format(new Date(selectedDate.value));
        });

        const validate = () => {
            let valid = true;
            if (client.value.phone.replace(/[^\d]/g, '').length != 11) {
                valid = false;
            }
            if ([
                car.value.brand,
                car.value.model,
                car.value.licenseNumber,
                client.value.name,
                selectedDate.value,
                selectedTime.value,
                selectedCenterId.value,
                Object.keys(selectedServices.value),
            ].filter(v => !v).length) {
                valid = false;
            }
            if (String(client.value.phone).length < 10 && client.value.phone) {
                valid = false;
                showMessage('Неверно указан номер телефона');
            }

            return {
                valid
            };
        }

        const submit = () => {
            let validateResult = validate();
            if (!validateResult.valid) {
                showMessage('Заполните обязательные поля');
                return;
            }
            let data = new FormData();
            data.append('centerId', selectedCenter.value.CODE);
            data.append('time', selectedTime.value);
            data.append('type', 'service');
            // data.append('tiresStored', this.tiresInStore ? 1 : 0);
            // data.append('contractNum', this.contractNum);
            data.append('date', selectedDate.value);
            data.append('licenseNumber', car.value.licenseNumber);
            // data.append('vinNumber', car.value.vinNumber);
            data.append('carBrand', car.value.brand);
            data.append('carModel', car.value.model);
            // data.append('carYear', car.value.year);
            // data.append('carShell', car.value.shell);
            data.append('client', client.value.name);
            // data.append('mileage', this.mileage);
            data.append('phone', client.value.phone);
            data.append('customAddress', '');
            data.append('lat', 0);
            data.append('lng', 0);
            for (var serviceId in selectedServices.value) {
                data.append('services[]', selectedServices.value[serviceId].UF_CODE);
            }
            // if ( this.mobileServiceSelected )
            // {
            //     data.comment = this.mobileServiceData.clarificationAddress;
            //     data.lat = +this.mobileServiceData.coordinates[ 0 ];
            //     data.lng = +this.mobileServiceData.coordinates[ 1 ];
            //     data.customAddress = this.mobileServiceData.address;
            // }
            submitServiceOrder(data).then(res => {
                if (res.id) {
                    order.value.id = res.id;
                    if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent) && res.icsFileLink) {
                        calendarLink.value = res.icsFileLink;
                    }
                    else {
                        if (res.googleCalendarLink) {
                            calendarLink.value = res.googleCalendarLink;
                        }
                    }
                    serviceOrderCompletePopup.value.open();
                }
                if (res.message) {
                    showMessage(res.message);
                }
            })
        };

        const expadedSteps = ref([1]);
        const toggleStep = step => {
            if (!~expadedSteps.value.indexOf(step)) {
                expadedSteps.value.push(step);
            }
            else {
                expadedSteps.value.splice(expadedSteps.value.indexOf(step), 1);
            }
        }

        const mapPlacemarks = computed(() => {
            let mapPlacemarks = [];
            for (var i = 0; i < availableCenters.value.length; i++) {
                if (availableCenters.value[i].LAT && availableCenters.value[i].LNG) {
                    mapPlacemarks.push({
                        center : availableCenters.value[i],
                        coords : [ availableCenters.value[i].LAT, availableCenters.value[i].LNG ]
                    });
                }
            }
            return mapPlacemarks;
        })

        const mapPlacemarkSelected = ({item}) => {
            if (item.center.ID) {
                selectedCenterId.value = item.center.ID;
            }
        }

        const goTo = url => window.location.href = url;

        return {
            goTo,
            mapPlacemarks,
            mapPlacemarkSelected,
            serviceOrderCompletePopup,
            expadedSteps,
            toggleStep,
            calendarLink,
            personalCars,
            selectedPersonalCarId,
            contactInfo,

            toggleService,
            selectTime,
            submit,

            tiresStored,
            order,
            client,
            selectedDateFormatted,
            selectedDate,
            selectedTime,
            car,
            selectedCenterId,
            selectedCenter,
            availableCenters,
            availableTime,
            availableTimeLoaded,
            serviceGroups,
            servicesByGroup,
            selectedServices,
        };
    }
}
</script>
